export default "__VITE_ASSET__DpJCVCLP__"